// extracted by mini-css-extract-plugin
export default {"AnimatedText":"styles_AnimatedText__FAhna","growAndBounce":"styles_growAndBounce__KUrh7"};